var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#303BA6",
    d: "M14.902 18.855c0 2.36-1.912 4.272-4.272 4.272-2.36 0-4.273-1.913-4.273-4.272 0-2.36 1.913-4.273 4.273-4.273 2.36 0 4.272 1.913 4.272 4.273",
    transform: "translate(.857 .978)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M19.971 17.566h-1.17v-7.074h-.01c-.087-3.554-2.44-6.542-5.67-7.576.019-.129.032-.258.032-.392C13.153 1.13 12.024 0 10.63 0 9.236 0 8.105 1.13 8.105 2.524c0 .134.014.264.034.392-3.23 1.034-5.583 4.023-5.671 7.576h-.01V17.566h-1.17c-.711 0-1.288.577-1.288 1.289 0 .711.577 1.288 1.288 1.288H19.97c.712 0 1.289-.577 1.289-1.288 0-.712-.577-1.289-1.289-1.289",
    transform: "translate(.857 .978)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.6a9b339a4366c0ad37608d2879b3b0c5.svg";
export { ForwardRef as ReactComponent };